import { getCookie } from "./cookies";
import { getFromLocalStorage } from "./storage";

export const isDebugAPI =
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  (typeof process !== "undefined" &&
    process.env &&
    process.env.LOGGER_ENABLED) ||
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  (typeof process !== "undefined" && process.env.LOGGER_ENABLED) ||
  getFromLocalStorage("logger-enabled") ||
  getCookie("logger-enabled");
